import React from "react";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";

function NoAccess() {
  return (
    <div data-testid="module-no-access" className="max-w-md mx-auto mt-24 text-center space-y-3">
      <div className="mx-auto h-12 w-12 rounded-2xl bg-rose-100 text-rose-600 dark:bg-rose-500/15 dark:text-rose-300 flex items-center justify-center">
        <Lock className="h-6 w-6" />
      </div>
      <h2 className="font-display text-xl font-semibold">No access to this module</h2>
      <p className="text-sm text-muted-foreground">Your Super Admin has turned this section off for your account.</p>
    </div>
  );
}

/**
 * Route guard. `perm` = CRM Access module key (per-user toggle wins);
 * `roles` = legacy role fallback when no permission payload is present.
 */
export function RoleGuard({ roles, perm, children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  const perms = user.permissions;
  if (perm && perms && perm in perms) return perms[perm] ? children : <NoAccess />;
  if (roles && roles.length && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
